import { defineAsyncComponent } from 'vue'

const defaultLayout = 'AppLayout'

const currentLayout = {
  name: null,
  component: null,
}

function getLayoutComponent (layoutName) {
  return defineAsyncComponent(() => import(`@/layouts/${layoutName}.vue`).catch(e => getLayoutComponent(defaultLayout)))
}

export function loadLayout (route) {
  const layoutName = route.meta.layout || defaultLayout

  if (currentLayout.name !== layoutName) {
    currentLayout.name = layoutName
    currentLayout.component = getLayoutComponent(layoutName)
  }

  route.meta.layoutComponent = currentLayout.component
}
